import {FC} from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useMarkdownRenderer } from "./useMarkdownRenderer";

const GameNameMarkdownRenderer: FC<{ children?: string }> = (props) => {
    const {children} = props;
    const { components } = useMarkdownRenderer();

    // Check if the content contains a table
    const containsTable = children?.includes('|') && children?.includes('---');

    // If it contains a table, preserve the formatting, otherwise replace single \n with double \n\n
    const formattedText = containsTable ? children : children?.replace(/\n/g, '\n\n');

    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={components}
        >
            {formattedText}
        </ReactMarkdown>
    )
}

export default GameNameMarkdownRenderer;
